/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

// import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'
import React from 'react'
import { Subscribe } from 'unstated'
import { withPropsOnChange } from 'recompose'
import { AppContainer } from 'containers/App'
import processReportData from 'utils/processQueries/reportData'

const ReportQueryContainer = Display => ({ className }) => {
  return (
    <Subscribe to={[AppContainer]}>
      {({ state: appData, ...setters }) => (
        <StaticQuery
          query={graphql`
            query {
              app: allDataJson {
                ...appData
              }
              coordinates: allLocationCoordinate {
                ...coordinateData
              }
              plots: allImageSharp(
                filter: { fields: { plotType: { nin: ["Bar","Photo"] } } }
              ) {
                ...plotData
              }
              ratings: allLawsonRating {
                ...ratingsData
              }
              settings: allDataYaml {
                ...settingsData
              }
              site {
                ...siteData
              }
              summaries: allLocationSummary {
                ...summaryData
              }
            }
          `}
          render={queryData => {
            const data = processReportData(queryData)
            return (
              <Display
                data={data}
                {...appData}
                setters={setters}
                className={className}
              />
            )
          }}
        />
      )}
    </Subscribe>
  )
}

export default ReportQueryContainer
